// @flow
import {List} from 'immutable';
import {Store} from 'client/framework';
import {isResourcePopulated, getResource} from 'resources/mandark.resource';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import appStore from 'client/AppStore';
import {stats} from 'lib/StatsUtil';

import type {AssignmentModelV2} from 'resources/Assignment/V2/Assignment.model.js';

class AssignmentOverviewGradeStore extends Store {
  getAssignmentQuery(): Object {
    return mandarkEndpoint(['students_v2', appStore.routerProps.params.userId, 'assignments_v3'])
      .filter({
        classrooms_v1: appStore.routerProps.params.classId
      })
      .filter({
        'meta.student_submitted': true
      })
      .customQuery({
        with_meta: 'assignment_v3'
      })
      .meta({
        context: {
          student: {
            id: appStore.routerProps.params.userId
          }
        }
      })
      .done();
  }

  hasAssignmentData(): boolean {
    return isResourcePopulated(this.getAssignmentQuery());
  }

  getAssignmentData(): List<AssignmentModelV2> {
    return getResource(this.getAssignmentQuery());
  }

  getAverageFunction(): Function {
    const total = this.getAssignmentData().reduce((acc, assignment) => {
      return acc + assignment.getMeta().getCountOfQuestions();
    }, 0);

    return (numerator: number) => {
      return stats.percentage(numerator, total);
    };
  }

  getCorrectAverage(): number {
    const average = this.getAverageFunction();
    const correct = this.getAssignmentData().reduce((acc, assignment) => {
      return acc + assignment.getMeta().getStudentCountOfCorrectGuesses();
    }, 0);

    return average(correct);
  }

  getIncorrectAverage(): number {
    const average = this.getAverageFunction();
    const incorrect = this.getAssignmentData().reduce((acc, assignment) => {
      const studentCorrectGuesses = assignment.getMeta().getStudentCountOfCorrectGuesses();
      const studentTotalGuesses = assignment.getMeta().getStudentCountOfGuesses();
      return acc + (studentTotalGuesses - studentCorrectGuesses);
    }, 0);

    return average(incorrect);
  }

  getNotAnsweredAverage(): number {
    const average = this.getAverageFunction();
    const notAnswered = this.getAssignmentData().reduce((acc, assignment) => {
      const totalPossible = assignment.getMeta().getCountOfQuestions();
      const notAnswered = totalPossible - assignment.getMeta().getStudentCountOfGuesses();
      return acc + notAnswered;
    }, 0);

    return average(notAnswered);
  }
}

export default new AssignmentOverviewGradeStore('AssignmentOverviewGradeStore');
